import React from "react";

export const BoundedAi = () => {
  return (
    <section
      id="bounded-ai"
      data-testid="section-bounded-ai"
      className="relative py-16 lg:py-20 border-t border-white/[0.06] bg-[#020B14]"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#0066FF]">
              Bounded AI
            </div>
            <h2
              data-testid="bounded-ai-headline"
              className="font-display text-2xl sm:text-3xl lg:text-[38px] mt-4 leading-[1.1]"
            >
              AI may assist.{" "}
              <span className="text-slate-400">Authorised roles decide.</span>
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p
              data-testid="bounded-ai-body"
              className="text-sm sm:text-base text-slate-300 leading-relaxed"
            >
              AI can identify, summarise or draft from approved evidence. It
              cannot approve an action, override a policy boundary or access
              withheld information.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
